var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-presentation" }, [
    _c("div", { staticClass: "type_reseau" }, [
      _c("i", { class: _vm.iconNetwork[_vm.Network] }),
      _vm._v("\n         " + _vm._s(_vm.Network) + "\n     "),
    ]),
    _c("img", { staticClass: "picture", attrs: { src: _vm.PictureUrl } }),
    _c("h3", [
      _vm._v(
        _vm._s(_vm.$t("dash.reporting.pdf.slideHome.rapport")) +
          " " +
          _vm._s(_vm.Network)
      ),
    ]),
    _c("h4", [_vm._v(_vm._s(_vm.PageName))]),
    _c("p", [
      _vm._v(
        _vm._s(
          _vm.DateStart.toLocaleString("fr-FR", {
            year: "numeric",
            month: "long",
            day: "numeric",
          })
        ) +
          " - " +
          _vm._s(
            _vm.DateEnd.toLocaleString("fr-FR", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          )
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }